<template>
  <v-container style="padding-top: 100px">
    <div v-if="showcargando == true" id="cargando" wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
      <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
      <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
      <p class="w-1/3 text-center text-white">
        Esto puede tardar unos segundos, no cierre esta página.
      </p>
    </div>
    <v-card style="justify-content: center">
      <v-card-title class="primary">
        <p style="color: white">Bitácora - Búsqueda</p>
        <v-spacer></v-spacer>
        <v-icon :color="'#FFFFFF'">mdi-table-search</v-icon>
      </v-card-title>
      <v-card-text class="pa-5 pt-4">
        <v-row>
          <v-col cols="12" md="9" sm="12">
            <v-form ref="form1" v-model="valid1" lazy-validation>
              <v-row>
                <v-col cols="12" md="4" sm="12" offset-md="1">
                  <span style="text-align: center; font-weight: bold">Número de reporte:</span>
                  <v-text-field class="pt-2" v-model="nrreporte" dense outlined min="0" @change="validarReporte"
                    maxlength="10" @keypress="validarRegex($event, 'N')" @paste="onPaste"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <span style="text-align: center; font-weight: bold">Número de serie:</span>
                  <v-text-field class="pt-2" v-model="serie" maxlength="30" dense outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" sm="12" offset-md="1">
                  <span style="text-align: center; font-weight: bold">Fecha Inicio Reporte:</span>
                  <v-dialog ref="dialog" outlined v-model="modal" persistent width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field class="pt-2" v-model="fechaInicio" label="" readonly outlined dense v-bind="attrs"
                        v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="fechaInicio" :max="date" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="
                        modal = false;
                      fechaInicio = null;
                      ">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(fechaInicio)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <span style="text-align: center; font-weight: bold">Fecha Fin Reporte:</span>
                  <v-dialog ref="dialog3" v-model="modal3" persistent outlined width="290px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field class="pt-2" v-model="fechaFin" label="" readonly :disabled="validafechaInicio"
                        :error-messages="validacionfechafin" :required="valfechafin" outlined dense v-bind="attrs"
                        v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="fechaFin" :min="fechaInicio" :max="date" locale="es" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="error" @click="
                        modal3 = false;
                      fechaFin = null;
                      ">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.dialog3.save(fechaFin)" style="color: white">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
          <v-divider class="mx-4" vertical></v-divider>
          <v-col cols="12" md="2" sm="12">
            <v-btn class="mr-4 mt-4" :color="dia == 1 ? 'accent' : 'warning'" @click="busquedaDias(1)" width="95%">1 día
              atrás</v-btn>
            <v-btn class="mr-4 mt-4" :color="dia == 2 ? 'accent' : 'warning'" @click="busquedaDias(2)" width="95%">2 días
              atrás</v-btn>
            <v-btn class="mr-4 mt-4" :color="dia == 3 ? 'accent' : 'warning'" @click="busquedaDias(3)" width="95%">3 días
              atrás</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions style="justify-content: center; align-content: end; padding: 20px">
        <div mt-2>
          <v-btn class="mr-4" color="#536DFE" @click="busquedaBitacora()" :disabled="!valfechafin == false"
            style="color: white">Buscar</v-btn>
          <v-btn class="mr-4" color="default" @click="limpiar">Limpiar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
    <br /><br />
    <v-card v-if="this.mostrarA">
      <v-card-title class="primary">
        <p style="color: white">Asistencia</p>
      </v-card-title>
      <v-card-text>
        <div class="table-responsive">
          <table id="datatableA" class="table table-hover display responsive no-wrap" width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-for="encabezado in hasistencia" :key="encabezado.id">
                  {{ encabezado.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reporte in datosA" :key="reporte.id">
                <td></td>
                <td
                  v-if="reporte.aiclave == 1 || reporte.aiclave == 24 || reporte.aiclave == 23 || reporte.aiclave == 2 || reporte.aiclave == 3 || reporte.aiclave == 9">
                  <a class="link" @click="BuscarReporte(reporte)">{{
                    reporte.nrreporte
                  }}</a>
                </td>
                <td v-else>{{ reporte.nrreporte }}</td>
                <td>{{ reporte.Asegurado }}</td>
                <td>{{ reporte.Fecha_y_Hora_Siniestro }}</td>
                <td>{{ reporte.Fecha_y_Hora_Reporte }}</td>
                <td>{{ reporte.Fecha_y_Hora_Contacto }}</td>
                <td>{{ reporte.Fecha_y_Hora_Termino }}</td>
                <td>{{ reporte.Localidad }}</td>
                <td>{{ reporte.Proveedor }}</td>
                <td>{{ reporte.Lugar_de_la_Averia }}</td>
                <td>{{ reporte.Lugar_de_Destino }}</td>
                <td>{{ reporte.Asistencia }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
    <br />
    <v-card v-if="this.mostrarA">
      <v-card-title class="primary">
        <p style="color: white">Juridico</p>
      </v-card-title>
      <v-card-text>
        <div class="table-responsive">
          <table id="datatableJ" class="table table-hover display responsive no-wrap" width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-for="encabezado in hjuridico" :key="encabezado.id">
                  {{ encabezado.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reporte in datosJ" :key="reporte.id">
                <td></td>
                <td v-if="reporte.aiclave == 1 || reporte.aiclave == 24 || reporte.aiclave == 23">
                  <a class="link" @click="BuscarReporte(reporte)">{{
                    reporte.nrreporte
                  }}</a>
                </td>
                <td v-else>{{ reporte.nrreporte }}</td>
                <td>{{ reporte.Siniestro }}</td>
                <td>{{ reporte.Fecha_y_Hora_Siniestro }}</td>
                <td>{{ reporte.Fecha_y_Hora_Reporte }}</td>
                <td>{{ reporte.Fecha_y_Hora_Contacto }}</td>
                <td>{{ reporte.Fecha_y_Hora_Termino }}</td>
                <td>{{ reporte.Localidad }}</td>
                <td>{{ reporte.Abogado }}</td>
                <td>{{ reporte.Tipo_Siniestro }}</td>
                <td>{{ reporte.Tipo_Delito }}</td>
                <td>{{ reporte.svcitas }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
    <br />
    <v-card v-if="this.mostrarA">
      <v-card-title class="primary">
        <p style="color: white">Otros</p>
      </v-card-title>
      <v-card-text>
        <div class="table-responsive">
          <table id="datatableO" class="table table-hover display responsive no-wrap" width="100%">
            <thead>
              <tr>
                <th></th>
                <th v-for="encabezado in hotros" :key="encabezado.id">
                  {{ encabezado.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="reporte in datosO" :key="reporte.id">
                <td></td>
                <td v-if="reporte.aiclave == 1 || reporte.aiclave == 24 || reporte.aiclave == 23">
                  <a class="link" @click="BuscarReporte(reporte)">{{
                    reporte.nrreporte
                  }}</a>
                </td>
                <td v-else>{{ reporte.nrreporte }}</td>
                <td>{{ reporte.Asegurado }}</td>
                <td>{{ reporte.Fecha_y_Hora_Siniestro }}</td>
                <td>{{ reporte.Fecha_y_Hora_Reporte }}</td>
                <td>{{ reporte.Fecha_y_Hora_Contacto }}</td>
                <td>{{ reporte.Fecha_y_Hora_Termino }}</td>
                <td>{{ reporte.Localidad }}</td>
                <td>{{ reporte.Proveedor }}</td>
                <td>{{ reporte.Lugar_de_la_Averia }}</td>
                <td>{{ reporte.Lugar_de_Destino }}</td>
                <td>{{ reporte.Asistencia }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Bitacora from "@/services/bitacora/Bitacora.service.js";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import "datatables.net-responsive-dt";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";

export default {
  components: {},
  data: function () {
    return {
      fechaInicio: null,
      fechaFin: "",
      modal: false,
      modal3: false,
      valid1: true,
      date: new Date().toISOString().substr(0, 10),
      loading: true,
      fechas: {
        start: this.$moment().subtract(1, "Y").format("YYYY-MM-DD hh:mm"),
        end: this.$moment().add(1, "days").format("YYYY-MM-DD hh:mm"),
        shortcut: undefined,
      },
      nrreporte: null,
      siniestro: "",
      serie: null,
      aux_nrreporte: "",
      svindice: "",
      loadingA: true,
      datosA: [],
      mostrarA: false,
      hasistencia: [
        { text: "Reporte", value: "nrreporte", class: "text title" },
        { text: "Asegurado", value: "Asegurado", class: "text title" },
        {
          text: "Fecha y Hora Siniestro",
          value: "Fecha_y_Hora_Siniestro",
          class: "text title",
        },
        {
          text: "Fecha y Hora Reporte",
          value: "Fecha_y_Hora_Reporte",
          class: "text title",
        },
        {
          text: "Fecha y Hora Contacto",
          value: "Fecha_y_Hora_Contacto",
          class: "text title",
        },
        {
          text: "Fecha y Hora Termino",
          value: "Fecha_y_Hora_Termino",
          class: "text title",
        },
        { text: "Localidad", value: "Localidad", class: "text title" },
        { text: "Proveedor", value: "Proveedor", class: "text title" },
        {
          text: "Lugar de la Avería",
          value: "Lugar_de_la_Averia",
          class: "text title",
        },
        {
          text: "Lugar de Destino",
          value: "Lugar_de_Destino",
          class: "text title",
        },
        { text: "Asistencia", value: "Asistencia", class: "text title" },
      ],
      loadingJ: true,
      datosJ: [],
      hjuridico: [
        { text: "Reporte", value: "nrreporte", class: "text title" },
        { text: "Siniestro", value: "Siniestro", class: "text title" },
        {
          text: "Fecha y Hora Siniestro",
          value: "Fecha_y_Hora_Siniestro",
          class: "text title",
        },
        {
          text: "Fecha y Hora Reporte",
          value: "Fecha_y_Hora_Reporte",
          class: "text title",
        },
        {
          text: "Fecha y Hora Contacto",
          value: "Fecha_y_Hora_Contacto",
          class: "text title",
        },
        {
          text: "Fecha y Hora Termino",
          value: "Fecha_y_Hora_Termino",
          class: "text title",
        },
        { text: "Localidad", value: "Localidad", class: "text title" },
        { text: "Abogado", value: "Abogado", class: "text title" },
        {
          text: "Tipo de Servicio",
          value: "Tipo_Siniestro",
          class: "text title",
        },
        { text: "Tipo de Delito", value: "Tipo_Delito", class: "text title" },
        { text: "Citas", value: "svcitas", class: "text title" },
      ],
      loadingO: true,
      datosO: [],
      hotros: [
        { text: "Reporte", value: "nrreporte", class: "text title" },
        { text: "Asegurado", value: "Asegurado", class: "text title" },
        {
          text: "Fecha y Hora Siniestro",
          value: "Fecha_y_Hora_Siniestro",
          class: "text title",
        },
        {
          text: "Fecha y Hora Reporte",
          value: "Fecha_y_Hora_Reporte",
          class: "text title",
        },
        {
          text: "Fecha y Hora Contacto",
          value: "Fecha_y_Hora_Contacto",
          class: "text title",
        },
        {
          text: "Fecha y Hora Termino",
          value: "Fecha_y_Hora_Termino",
          class: "text title",
        },
        { text: "Localidad", value: "Localidad", class: "text title" },
        { text: "Proveedor", value: "Proveedor", class: "text title" },
        {
          text: "Lugar de la Avería",
          value: "Lugar_de_la_Averia",
          class: "text title",
        },
        {
          text: "Lugar de Destino",
          value: "Lugar_de_Destino",
          class: "text title",
        },
        { text: "Asistencia", value: "Asistencia", class: "text title" },
      ],
      showcargando: false,
      valfechafin: false,
      validacionfechafin: null,
      validafechaInicio: true,
      dia: null,
    };
  },
  watch: {
    async fechaInicio(val) {
      if (val != null) {
        this.validafechaInicio = false;
        this.fechaFin = null;
        this.validacionfechafin = "El campo es requerido";
        this.valfechafin = true;
      } else {
        this.validafechaInicio = true;
        this.validacionfechafin = null;
        this.valfechafin = false;
        this.fechaFin = null;
      }
    },
    async fechaFin(val) {
      if (val == null && this.fechaInicio != null) {
        this.valfechafin = true;
        this.validacionfechafin = "El campo es requerido";
      } else {
        this.valfechafin = false;
        this.validacionfechafin = null;
      }
    },
  },
  computed: {
    ...mapState({ drawer: (state) => state.drawer }),
    ...mapState(["domain", "informationPage"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
  },
  methods: {
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData("text");
      if (isNaN(pastedData)) {
        event.preventDefault();
      }
    },
    validarReporte: function (e) {
      this.aux_nrreporte = e;
      this.nrreporte = this.aux_nrreporte.split("-");
      this.nrreporte = this.nrreporte[0];
    },
    validarRegex(evt, tipo) {
      return MetodosGenerales.validarRegex(evt, tipo);
    },
    busquedaBitacora() {
      this.dia = null;
      if (this.serie != null) {
        this.serie = this.serie.trim();
      }
      if (
        this.nrreporte == null &&
        (this.serie == null || this.serie == "") &&
        this.fechaInicio == null &&
        (this.fechaFin == "" || this.fechaFin == null)
      ) {
        this.$swal({
          position: "center",
          icon: "warning",
          title: "Error",
          text: "Debe ingresar al menos un dato",
          showConfirmButton: true,
          allowOutsideClick: false,
        });
      } else {
        this.showcargando = true;
        if (this.nrreporte != null) {
          this.nrreporte = this.nrreporte.trim();
        }

        var busquedaBitacora = new FormData();
        busquedaBitacora.append("dias", null);
        busquedaBitacora.append("reporte", this.nrreporte);
        busquedaBitacora.append("fecini", this.fechaInicio);
        busquedaBitacora.append("fecfin", this.fechaFin);
        busquedaBitacora.append("numserie", this.serie);
        this.busquedaReportes(busquedaBitacora);
      }
    },
    limpiar() {
      this.nrreporte = null;
      this.serie = null;
      this.fhinicio = "";
      this.fhfin = "";
      this.fechas = {};
      this.fechaInicio = null;
      this.fechaFin = "";
      this.$refs.form1.reset();
      this.datosA = [];
      this.datosJ = [];
      this.datosO = [];
      this.mostrarA = false;
      this.validacionfechafin = null;
      this.valfechafin = false;
      this.dia = null;
    },
    async BuscarReporte(item) {
      let aux = item.nrreporte.split("-");
      let _svindice = aux[1];
      let _nrreporte = aux[0];

      let reporte = {
        nrreporte: _nrreporte,
        svindice: _svindice,
        aiclave: item.aiclave,
        svfhconclusion: item.svfhconclusion,
      };
      let routerName = MetodosGenerales.obtenerRouterName(
        parseInt(item.aiclave)
      );
      //ManagerLocalStorage.guardarEnSesionInfoReporte(item);
      await MetodosGenerales.guardarEnSesionInfoReporte(reporte, "reporte");
      this.$router.push({ name: `${routerName}`, params: { id: 0 } });
    },
    async busquedaReportes(datosbusqueda) {
      this.mostrarA = false;
      let asistencias = await Bitacora.ObtenerReportesAsistencias(
        this,
        datosbusqueda
      );
      for (let i in asistencias) {
        for (const [key, value] of Object.entries(asistencias[i])) {
          if (typeof value === "object") {
            asistencias[i][key] = "";
          } else {
            asistencias[i][key] = value.toString();
          }
        }
      }
      this.datosA = asistencias;
      this.loadingA = false;

      let juridicos = await Bitacora.ObtenerReportesJuridicos(
        this,
        datosbusqueda
      );
      for (let i in juridicos) {
        for (const [key, value] of Object.entries(juridicos[i])) {
          if (typeof value == "object") {
            juridicos[i][key] = "";
          } else {
            juridicos[i][key] = value.toString();
          }
        }
      }
      this.datosJ = juridicos;
      this.loadingJ = false;

      let otros = await Bitacora.ObtenerOtrosReportes(this, datosbusqueda);

      for (let i in otros) {
        for (const [key, value] of Object.entries(otros[i])) {
          if (typeof value == "object") {
            otros[i][key] = "";
          } else {
            otros[i][key] = value.toString();
          }
          if (typeof otros[i]["Lugar_de_Destino"] == "object") {
            otros[i]["Lugar_de_Destino"] = " ";
          }
        }
      }
      this.datosO = otros;
      this.loadingO = false;
      this.showcargando = false;

      this.mostrarA = true;
      setTimeout(() => {
        $("#datatableA").DataTable({
          dom: "iftlp",
          lengthMenu: [
            [20, 50, 100],
            [20, 50, 100],
          ],
          paginate: true,
          pageLength: 20,
          responsive: {
            details: {
              type: 'column'
            }
          },
          columnDefs: [{
            className: 'dtr-control',
            orderable: false,
            targets: 0
          }],
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Sin registros encontrados",
            sInfo: "",
            sInfoEmpty: "",
            sInfoFiltered: "",
            sInfoPostFix: "",
            search: "",
            searchPlaceholder: "Filtrar...",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "&raquo;",
              sPrevious: "&laquo;",
            },
            oAria: {
              sSortAscending:
                ": Activar para ordenar la columna de manera ascendente",
              sSortDescending:
                ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
        $("#datatableJ").DataTable({
          dom: "iftlp",
          lengthMenu: [
            [20, 50, 100],
            [20, 50, 100],
          ],
          paginate: true,
          pageLength: 20,
          responsive: {
            details: {
              type: 'column'
            }
          },
          columnDefs: [{
            className: 'dtr-control',
            orderable: false,
            targets: 0
          }],
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Sin registros encontrados",
            sInfo: "",
            sInfoEmpty: "",
            sInfoFiltered: "",
            search: "",
            sInfoPostFix: "",
            searchPlaceholder: "Filtrar...",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "&raquo;",
              sPrevious: "&laquo;",
            },
            oAria: {
              sSortAscending:
                ": Activar para ordenar la columna de manera ascendente",
              sSortDescending:
                ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
        $("#datatableO").DataTable({
          dom: "iftlp",
          lengthMenu: [
            [20, 50, 100],
            [20, 50, 100],
          ],
          paginate: true,
          pageLength: 20,
          responsive: {
            details: {
              type: 'column'
            }
          },
          columnDefs: [{
            className: 'dtr-control',
            orderable: false,
            targets: 0
          }],
          language: {
            sProcessing: "Procesando...",
            sLengthMenu: "Mostrar _MENU_ registros",
            sZeroRecords: "No se encontraron resultados",
            sEmptyTable: "Sin registros encontrados",
            sInfo: "",
            sInfoEmpty: "",
            sInfoFiltered: "",
            search: "",
            sInfoPostFix: "",
            searchPlaceholder: "Filtrar...",
            sUrl: "",
            sInfoThousands: ",",
            sLoadingRecords: "Cargando...",
            oPaginate: {
              sFirst: "Primero",
              sLast: "Último",
              sNext: "&raquo;",
              sPrevious: "&laquo;",
            },
            oAria: {
              sSortAscending:
                ": Activar para ordenar la columna de manera ascendente",
              sSortDescending:
                ": Activar para ordenar la columna de manera descendente",
            },
          },
        });
      });
      setTimeout(() => { }, "500");
    },
    busquedaDias(dia) {
      this.showcargando = true;
      this.limpiar();
      this.dia = dia;
      var busquedaBitacora = new FormData();
      busquedaBitacora.append("dias", dia);
      busquedaBitacora.append("reporte", null);
      busquedaBitacora.append("fecini", null);
      busquedaBitacora.append("fecfin", null);
      busquedaBitacora.append("numserie", null);
      this.busquedaReportes(busquedaBitacora);
    },
  },
  mounted() {
    this.fechas = {};
  },
};
</script>